"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createParamsMapper = createParamsMapper;
const validators_1 = require("../validators/index.js");
function createParamsMapper({ prefixes }) {
    function parseKey(segments) {
        const { first } = segments;
        if (segments.second && segments.third) {
            return segments.third;
        }
        if (segments.second) {
            return segments.second;
        }
        return first;
    }
    function parseGroup(segments) {
        const { first } = segments;
        if (segments.third) {
            return segments.second;
        }
        if (segments.second) {
            if ((0, validators_1.isPrefix)({ segment: first, validPrefixes: prefixes })) {
                return undefined;
            }
            return first;
        }
        return undefined;
    }
    const mappedParams = {
        key: (segments) => parseKey(segments),
        group: (segments) => parseGroup(segments),
    };
    return { mappedParams };
}
